export default __webpack_public_path__ + "static/media/cincoClosed.6d44c6b4.jpg";